export default __webpack_public_path__ + "static/media/eye.f8268044.svg";